<template>
	<div class="component-container">
		<!--bind ComputerAlert to isOpen data and register listener for the alert to be clicked-->
		<ComputerAlert v-bind:isOpen="isOpen" v-on:onClickComputerAlert="isOpen = true"></ComputerAlert>
		<div class="email" v-show="isOpen">
			<div class="vuebar-element" v-bar="{ preventParentScroll: true, useScrollbarPseudo: true}">
				<div class="vuebar-content">
					<div class="email-content">
						<div class="email-header">
							From: Shady Sam<br />
							To: {{getPlayerName}}<br />
							Date: {{formatedDate}}<br />
							Subject: {{email_data.email_subject}}
						</div>
						<div class="divider"></div>
						<div class="email-body">
							<div v-html="emailBody"></div>
							<div class="shares">
								<div class="share-header">
									Share your new nickname:
								</div>
								<ShareButtons></ShareButtons>
							</div>
						</div>
						<Button class="startBtn" :action="closeEmail">{{email_data.email_close_button}}</Button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import Button from '@/components/abstract/Button';
import ComputerAlert from '@/components/abstract/ComputerAlert';
import ShareButtons from '@/components/abstract/ShareButtons';
import random from '@/mixins/random';
import tracking from '@/mixins/tracking';


export default {
	name: 'GameOverEmail',
	mixins: [random, tracking],
	data() {
		return {
			isOpen: false,
			adjectives: [],
		};
	},
	components: {
		Button,
		ComputerAlert,
		ShareButtons,
	},
	computed: {
		...mapState({ // get data from wordpress
			email_data: state => state.config.data.email.find(email => email.email_type === "Game Over"),
			game_config: state => state.config.data.game_config,
		}),
		getPlayerName() {
			return this.$store.state.playerName;
		},
		formatedDate() {
			return this.$store.state.todaysDate;
		},
		performance() {
			const score = this.$store.state.score;
			if (score < 1.67) {
				return 'High Performers';
			} else if (score > 2.34) {
				return 'Poor Performers';
			}
			return 'Average Performers';
		},
		setAdjective() { // getting random adjective based on performance level
			const adjs = this.$store.getters.getAdjectivesByPerformance(this.performance);
			const adj = adjs.nicknames[Math.floor(Math.random() * adjs.nicknames.length)].adjective;
			this.$store.commit('setAdjective', adj);
			return adj;
		},
		emailBody() {
			let s = '';
			let rewardMsg = "";
			if (this.performance === 'High Performers') {
				rewardMsg = this.randomValue(this.email_data.good_copy);
			} else if (this.performance === 'Average Performers') {
				rewardMsg = this.randomValue(this.email_data.medium_copy);
			} else {
				rewardMsg = this.randomValue(this.email_data.bad_copy);
			}
			s = rewardMsg.copy_option;
			s = s.replace(new RegExp("{{Adjective}}", 'g'), this.setAdjective);
			s = s.replace(new RegExp("{{Name}}", 'g'), this.getPlayerName);
			s = s.replace(new RegExp("{{userTotal}}", 'g'), this.formattedMoney);
			return s;
		},
		formattedMoney() {
			return this.formatMoney(this.$store.state.totalMoney);
		},
	},
	methods: {
		closeEmail() {
			// Go to Game Over Screen
			this.$router.push({ name: 'GameOver' });
		},
		formatMoney(amt) {
			return amt.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		},
	},
	mounted() {
		this.trackPageview(`email-final`, `/level-4/email`);
	},
};
</script>

<style lang="scss" scoped>
		// global email styles are in base-classes
		.share-header{
			margin: 20px 0;
		}
</style>



// WEBPACK FOOTER //
// src/components/emails/GameOverEmail.vue